import moment from "moment";

import { parseUtcMs } from "../../utils/liveView";

export function formatClock(totalSeconds: number): string {
  const safe = Math.max(0, Math.round(totalSeconds));
  const hours = Math.floor(safe / 3600);
  const minutes = Math.floor((safe % 3600) / 60);
  const seconds = safe % 60;
  return [hours, minutes, seconds]
    .map((part) => String(part).padStart(2, "0"))
    .join(":");
}

export function parseClock(value: string): number | null {
  const match = /^(\d{1,3}):([0-5]?\d):([0-5]?\d)$/.exec(value.trim());
  if (!match) return null;
  return Number(match[1]) * 3600 + Number(match[2]) * 60 + Number(match[3]);
}

export function formatRecordedDuration(totalSeconds: number): string {
  const safe = Math.max(0, Math.round(totalSeconds));
  const minutes = Math.floor(safe / 60);
  const seconds = safe % 60;
  if (minutes === 0) return `${seconds} s`;
  if (seconds === 0) return `${minutes} min`;
  return `${minutes} min ${seconds} s`;
}

export function formatTime(value: string | null): string | null {
  const ms = parseUtcMs(value);
  return ms === null ? null : moment(ms).format("HH:mm");
}

export function formatDateTime(
  value: string | null,
  format: string,
): string | null {
  const ms = parseUtcMs(value);
  return ms === null ? null : moment(ms).format(format);
}

// "Ready at" time of a scheduled live: the start minus the 5 min activation.
export function formatReadyTime(value: string | null): string | null {
  const ms = parseUtcMs(value);
  return ms === null ? null : moment(ms).subtract(5, "minutes").format("HH:mm");
}

export function getRemainingSeconds(
  liveEnd: string | null,
  now: number,
): number | null {
  const endMs = parseUtcMs(liveEnd);
  return endMs === null ? null : Math.max(0, Math.round((endMs - now) / 1000));
}

export function maskKey(key: string): string {
  return `${"•".repeat(12)}${key.slice(-4)}`;
}
